class ConditionalRenderer {
    conditions:Array<(() => boolean)> = [];

    public addCondition(condition: (() => boolean)): ConditionalRenderer {
        this.conditions.push(condition);
        return this;
    }

    public validate(): boolean {
        return ConditionalRenderer.inlineValidate(this.conditions);
    }

    public static inlineValidate(conditions:Array<(() => boolean)>): boolean {
        for(let i = 0; i < conditions.length; i ++) {
            if(!conditions[i]()) return false;
        }

        return true;
    }
}

export default ConditionalRenderer;